import React from "react";
import { AHIcon, AHText, Box } from "arkh";
import { FormattedMessage } from "react-intl";

export function WorkspaceTodoDetailIndicator(props: {
  status: "DRAFT" | "PUBLISHED" | "SCHEDULED" | "ARCHIVED";
}) {
  switch (props.status) {
    case "DRAFT":
      return <DraftIndicator />;
    case "SCHEDULED":
      return <ScheduledDraftIndicator />;
    case "PUBLISHED":
      return null;
    case "ARCHIVED":
      return null;
  }
  return null;
}
export function DraftIndicator() {
  return (
    <Box style={{ flexDirection: "row" }}>
      <Box
        color="background"
        cornerRadius="small"
        style={{ flexDirection: "row" }}
      >
        <Box
          spaceHorizontal="small"
          style={{ flexDirection: "row", alignItems: "center" }}
        >
          <AHIcon type="edit" color="text-secondary" size="xxsmall" />
          <AHText
            space="xsmall"
            cornerRadius="large"
            textAlign="center"
            type="detail"
            color="text-secondary"
            selectable={false}
          >
            <FormattedMessage
              defaultMessage="Draft"
              description="Workspace Todo Draft Label"
            />
          </AHText>
        </Box>
      </Box>
    </Box>
  );
}

export function ScheduledDraftIndicator() {
  return (
    <Box style={{ flexDirection: "row" }}>
      <Box
        color="surface-background-selected"
        cornerRadius="small"
        spaceVertical="xsmall"
        borderColor="primary"
      >
        <Box
          spaceHorizontal="small"
          style={{ flexDirection: "row", alignItems: "center" }}
        >
          <AHIcon type="calendar" color="primary" size="xxsmall" />
          <AHText
            selectable={false}
            spaceLeft="xsmall"
            type="detail"
            color="primary"
          >
            <FormattedMessage
              defaultMessage="Scheduled"
              description="Workspace Todo Draft Label"
            />
          </AHText>
        </Box>
      </Box>
    </Box>
  );
}
